import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { ExtensionDisplayType } from 'src/models/ts/extension-display-type.model';
import { GridCellBaseComponent } from '../grid-cell-base/grid-cell-base.component';
import { InstanceStatusType } from 'src/models/ts/instance-status-type.model';
import { ExtensionIconComponent } from '../../../ui/icon/extension-icon/extension-icon.component';
import { IconComponent } from '../../../ui/icon/icon.component';
import { NetworkService } from 'src/app/core/services/network/network.service';
import { PwaService } from 'src/app/core/services/pwa/pwa.service';
import { KeepOfflineService } from 'src/app/core/services/keep-offline/keep-offline.service';
import { SyncQueueService } from 'src/app/core/services/sync/sync-queue.service';
import { filter, Subscription } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChangeDetectionService } from 'src/app/core/services/change-detection/change-detection.service';

export enum OfflineSyncType {
  None,
  Downloading,
  Downloaded,
  Failed
}

/**
 * Cell containing a file extension icon and text
 * Can contain both or either.
 */
@Component({
  selector: 'bizz-grid-cell-extension',
  templateUrl: './grid-cell-extension.component.html',
  styleUrls: ['./grid-cell-extension.component.scss'],
  imports: [
    ExtensionIconComponent,
    IconComponent
  ],
  standalone: true
})
export class GridCellExtensionComponent extends GridCellBaseComponent<InstanceStatusType> {
  public networkService = inject(NetworkService);
  public pwaService = inject(PwaService);
  public keepOfflineService = inject(KeepOfflineService);
  public syncService = inject(SyncQueueService);
  public state: OfflineSyncType = OfflineSyncType.None;
  public destroyRef = inject(DestroyRef);
  // eslint-disable-next-line @typescript-eslint/naming-convention
  protected readonly ExtensionDisplayType = ExtensionDisplayType;
  protected readonly OfflineSyncType = OfflineSyncType;
  private currentItemCompleteSubscription$: Subscription | undefined;
  

  public override onDataChanged(): void {
    if (this.pwaService.isPwa()) {
      this.state = OfflineSyncType.None;
      if (this.keepOfflineService.offlineInstanceCached(this.data.CollectionsID!, this.data.ID, this.data.VersionsID, !!this.data.FoldersID)) {
        this.state = OfflineSyncType.Downloaded;
      } else if(this.keepOfflineService.offlineInstanceDownloading(this.data.CollectionsID!, this.data.ID, this.data.VersionsID, !!this.data.FoldersID)) {
          this.state = OfflineSyncType.Downloading;
        } else if(this.keepOfflineService.offlineInstanceFailed(this.data.CollectionsID!, this.data.ID, this.data.VersionsID, !!this.data.FoldersID)) {
            this.state = OfflineSyncType.Failed;
      }
    this.currentItemCompleteListener();
  }
  ChangeDetectionService.detectChanges(this.changeDetectorRef);
  }

  private currentItemCompleteListener(): void {
    if (this.currentItemCompleteSubscription$) {
      this.currentItemCompleteSubscription$.unsubscribe();
    }
    this.currentItemCompleteSubscription$ = this.syncService.currentItemComplete2$.pipe(filter(res => res.collectionId === this.data.CollectionsID && res.instanceId === this.data.ID), takeUntilDestroyed(this.destroyRef)).subscribe((item) => {
        this.state = item.state;
        ChangeDetectionService.detectChanges(this.changeDetectorRef);
      });
    }
}


